import React, { Component } from "react";
import classNames from "classnames";
import style from "./style.css";

class TabSelector extends Component {
  constructor() {
    super();
    this.state = {
      isSignupTabActive: false,
      isloginTabActive: true
    };
  }

  state;

  onTabClickHandler;

  onTabClickHandler = (e) => {
    e.preventDefault();
    this.setState({
      isSignupTabActive: !this.state.isSignupTabActive,
      isloginTabActive: !this.state.isloginTabActive
    });
    this.props.changeActiveTab();
  };
  props;

  render() {
    const signupTabStyle = classNames({
      [style.tabSelector]: true,
      [style.activeTab]: this.state.isSignupTabActive
    });

    const loginTabStyle = classNames({
      [style.tabSelector]: true,
      [style.activeTab]: this.state.isloginTabActive
    });

    return (
      <div className={style.tabSelectorContainer}>
        <div className={signupTabStyle}>
          <button className={style.btnTab} onClick={this.onTabClickHandler}>
            new to tvg?
          </button>
        </div>
        <div className={loginTabStyle}>
          <button className={style.btnTab} onClick={this.onTabClickHandler}>
            login
          </button>
        </div>
      </div>
    );
  }
}

export default TabSelector;
